'use client';

import { Button, ButtonProps, PolymorphicComponentProps } from '@mantine/core';
import { forwardRef } from 'react';

import { trackButtonClick } from '@/utils/analytics';

type TrackedButtonProps = PolymorphicComponentProps<
  'button',
  ButtonProps & {
    trackingName?: string;
    trackingProperties?: Record<string, unknown>;
  }
>;

/**
 * Enhanced Button component that integrates with Vercel Analytics
 * Automatically tracks clicks when trackingName is provided
 */
const TrackedButton = forwardRef<HTMLButtonElement, TrackedButtonProps>(
  ({ trackingName, trackingProperties, onClick, ...props }, ref) => {
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      // Track the button click if tracking is enabled for this button
      if (trackingName) {
        trackButtonClick(trackingName, trackingProperties);
      }

      // Call the original onClick handler if provided
      if (onClick) {
        onClick(event);
      }
    };

    return (
      <Button
        ref={ref}
        onClick={handleClick}
        {...props}
      />
    );
  },
);

TrackedButton.displayName = 'TrackedButton';

export type { TrackedButtonProps };
export { TrackedButton };
